export enum FileType {
  Image = 'image',

  Video = 'video',

  Other = 'other',
}